import React, { useEffect, useState } from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';

import UserProfileForm from '_forms/userProfileForm';
import useCanAdminLicenses from '../../../hooks/useCanAdminLicenses';

const UserProfile = ({
  profile,
  onProfileSubmit,
}) => {
  const canAdmin = useCanAdminLicenses();
  const [userProfile, setUserProfile] = useState(profile);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    if (profile !== userProfile) {
      setUserProfile(profile);
      setDirty(false);
    }
  }, [profile]);

  const handleChange = (e, data) => {
    const newProfile = R.merge(
      userProfile,
      { [data.name]: R.has('checked', data) ? data.checked : data.value }
    );

    setUserProfile(newProfile);
    setDirty(true);
  };

  const handleCancel = () => {
    setUserProfile(profile);
    setDirty(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onProfileSubmit(userProfile);
    setDirty(false);
  };

  return (
    <UserProfileForm
      profile={userProfile}
      dirty={dirty}
      onSubmit={handleSubmit}
      onChange={handleChange}
      onCancel={handleCancel}
      readOnly={!canAdmin}
    />
  );
};

UserProfile.propTypes = {
  onProfileSubmit: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
}

export default UserProfile;



// WEBPACK FOOTER //
// ./webAdmin/components/users/user/profile.js